module.exports = __webpack_public_path__ + "img/chess-board.93434bee.svg";